module.exports = __webpack_public_path__ + "static/img03-730dfc29b7683d731ad3291842859bc5.jpg";